import { render, staticRenderFns } from "./Approachs.vue?vue&type=template&id=767fcf8b&"
import script from "./Approachs.vue?vue&type=script&lang=js&"
export * from "./Approachs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports